import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = (baseURL => {
  return {
    enqueue: (idList, idMessage) =>
      `${baseURL}/api/lists/${encodeURIComponent(
        idList
      )}/messages/${encodeURIComponent(idMessage)}/enqueue`,
    getQueuing: idQueuing =>
      `${baseURL}/api/queuings/${encodeURIComponent(idQueuing)}`,
    getScheduledSendings: (idList, params) =>
      `${baseURL}/api/lists/${encodeURIComponent(
        idList
      )}/scheduledsendings?${encodeParams(params)}`,
    enqueueRetry: idQueuing =>
      `${baseURL}/api/queuings/${encodeURIComponent(idQueuing)}/retry`,
    patchSchedule: idSchedule =>
      `${baseURL}/api/schedules/${encodeURIComponent(idSchedule)}`,
    cancelSchedule: idSchedule =>
      `${baseURL}/api/schedules/${encodeURIComponent(idSchedule)}/cancel`,
    deleteSending: idSending =>
      `${baseURL}/api/sendings/${encodeURIComponent(idSending)}`,
    updateScheduleState: idSchedule =>
      `${baseURL}/api/schedules/${encodeURIComponent(idSchedule)}/state`,
    addAgentDeclarationLog: idAgent =>
      `${baseURL}/api/agents/${encodeURIComponent(idAgent)}/declaration/log`
  }
})(process.env.BERCSSEND_URL)

export const beRcsSendDeleteSending = idSending => {
  const url = endpoints.deleteSending(idSending)
  return apiWrapper({
    method: 'delete',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beRcsSendCancelSchedule = idSchedule => {
  const url = endpoints.cancelSchedule(idSchedule)
  return apiWrapper({
    method: 'patch',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beRcsSendUpdateScheduleState = (idSchedule, params) => {
  const url = endpoints.updateScheduleState(idSchedule)
  return apiWrapper({
    method: 'patch',
    url: url,
    data: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beRcsSendPatchSchedule = (idSchedule, params) => {
  const url = endpoints.patchSchedule(idSchedule)
  return apiWrapper({
    method: 'patch',
    url: url,
    data: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beRcsSendEnqueue = (idList, idMessage, params) => {
  const url = endpoints.enqueue(idList, idMessage)
  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beRcsSendAddAgentDeclarationLog = (idAgent, params) => {
  const url = endpoints.addAgentDeclarationLog(idAgent)
  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beRcsSendEnqueueRetry = idQueuing => {
  const url = endpoints.enqueueRetry(idQueuing)
  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify({}),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beRcsSendGetQueuing = idQueuing => {
  const url = endpoints.getQueuing(idQueuing)
  return apiWrapper({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beRcsGetScheduledSendings = (idList, params) => {
  const url = endpoints.getScheduledSendings(idList, params)
  return apiWrapper({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}
export const RCS_QUEUING_RUNNING = 'QueuingRunning'
export const RCS_QUEUING_ERROR = 'QueuingError'
export const RCS_SENDING_READY = 'SendingReady'
export const RCS_SENDING_RUNNING = 'SendingRunning'
export const RCS_SENDING_ERROR = 'SendingError'
export const RCS_SENDING_NO_CREDIT = 'SendingNoCredits'
export const RCS_SCHEDULED_READY = 'SendingScheduledReady'
export const RCS_SENDING_STOPPING = 'SendingStopping'
export const RCS_SENDING_STOPPED = 'SendingStopped'
export const RCS_SENDING_FAILED = 'SendingFailed'
